<template>
  <div class="row padd-0">
    <div class="col-12 padd-0">
      <!-- v-for="(vhnotes, vehkey) in note.vhs" :key="vehkey" -->
      <div class="row vehnote-style">
        <div class="col-4" style="border-right: 1px solid lightgrey;">
          <div class="row">
            <div class="col-2" style="padding:0;">
              <img
                style="width:inherit;"
                src="https://firebasestorage.googleapis.com/v0/b/car-appointment-fsqahl.appspot.com/o/roomadmin_pictures%2Fcar_icon.png?alt=media&token=eae59a52-c909-4e85-979c-e5bdfbddeeed"
              />
            </div>
            <div class="col-10" v-if="veh != ''" style="text-align:left;">
              <p
                class="bold-color-txt"
                style="padding-top:10px;"
              >{{veh.make}} {{veh.model}} ({{veh.year}})</p>

              <p>
                VinNo:
                <span
                  class="bold-color-txt"
                >{{veh.id.substring(0, 3) == 'new' ? 'New Vehicle (not on file)' : veh.id}}</span>
              </p>
              <p v-if="veh.odometer">
                Odometer specified:
                <span class="bold-color-txt">{{veh.odometer || 'not specified'}}</span>
              </p>
            </div>
            <div class="col-8" style="text-align:left;" v-else>
              <p class="bold-color-txt" style="padding-top:10px;">N/A</p>
            </div>
          </div>
        </div>
        <div class="col-8">
          <div
            class="row request-style"
            v-for="(vhnote, vhindex) in sorted(notifications)"
            :key="vhindex"
          >
            <div class="col-12">
              <div
                class="row"
                v-for="(linetxts, vhtxtIndexs) in formDetails(vhnote).notetxt"
                :key="vhtxtIndexs"
                style="padding-top: 5px;"
              >
                <div v-for="(linetxt, vhtxtIndex) in linetxts" :key="vhtxtIndex">
                  <span
                    v-if="linetxt.txt != ''"
                    :class="linetxt.format != 'none' ? linetxt.format : ''"
                    :style="vhtxtIndex != 0 ? 'margin-left: 5px;' : ''"
                  >{{linetxt.txt}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotifData",
  components: {},
  props: {
    notifications: Array
  },
  data() {
    return {};
  },

  computed: {
    veh() {
      let r = this.notifications.find(el => el.vehicle.id != "");
      return r ? r.vehicle : "";
    }
  },

  watch: {},

  mounted() {},

  methods: {
    sorted(arr) {
      return arr.sort((a, b) =>
        a.created_time.seconds > b.created_time.seconds
          ? -1
          : b.created_time.seconds > a.created_time.seconds
          ? 1
          : 0
      );
    },
    formDetails(dataInfo) {
      dataInfo["notetxt"] = [];
      if (dataInfo.note_type == "appointment") {
        if (dataInfo.appointment.action == "schedule") {
          dataInfo["notetxt"].push(
            [
              {
                txt: `Client scheduled appointment for`,
                format: "bold-only"
              },
              {
                txt: `${new Date(
                  dataInfo.appointment.date + "T12:00:00-00:00"
                ).toDateString()} at ${dataInfo.appointment.time}`,
                format: "red-bold"
              }
            ],
            [
              {
                txt: `${
                  dataInfo.appointment.service_request != ""
                    ? "Client specified the following: "
                    : "No service requests specified"
                }`,
                format: "bold-only"
              },
              {
                txt: `${
                  dataInfo.appointment.service_request != ""
                    ? dataInfo.appointment.service_request
                    : ""
                }`,
                format: "blue-regular"
              }
            ]
          );
        } else if (dataInfo.appointment.action == "reschedule") {
          dataInfo["notetxt"].push(
            [
              {
                txt: `Client rescheduled appointment (DMS appt.No: `,
                format: "bold-only"
              },
              {
                txt: `${dataInfo.apptId || "N/A"}) for ${new Date(
                  dataInfo.appointment.date + "T12:00:00-00:00"
                ).toDateString()} at ${dataInfo.appointment.time}`,
                format: "red-bold"
              }
            ],
            [
              {
                txt: `${
                  dataInfo.appointment.service_request != ""
                    ? "Client specified the following:"
                    : "with no service requests specified"
                }`,
                format: "bold-only"
              },
              {
                txt: `${
                  dataInfo.appointment.service_request != ""
                    ? dataInfo.appointment.service_request
                    : ""
                }`,
                format: "blue-regular"
              }
            ],
            [
              {
                txt: `Previous appointment (DMS appt.No:`,
                format: "bold-only"
              },
              {
                txt: `${dataInfo.apptId || "N/A"}) was scheduled for ${new Date(
                  dataInfo.previousAppointment.date + "T12:00:00-00:00"
                ).toDateString()} at ${dataInfo.previousAppointment.time}`,
                format: "blue-bold"
              }
            ],
            [
              {
                txt: `${
                  dataInfo.previousAppointment.service_request != ""
                    ? "Previously client specified the following:"
                    : "with no service requests specified previously"
                }`,
                format: "bold-only"
              },
              {
                txt: `${
                  dataInfo.previousAppointment.service_request != ""
                    ? dataInfo.previousAppointment.service_request
                    : ""
                }`,
                format: "blue-regular"
              }
            ]
          );
        } else if (dataInfo.appointment.action == "cancel") {
          dataInfo["notetxt"].push([
            {
              txt: `Client canceled appointment (DMS appt.No: ${dataInfo.apptId ||
                "N/A"}) for ${new Date(
                dataInfo.previousAppointment.date + "T12:00:00-00:00"
              ).toDateString()} at ${dataInfo.previousAppointment.time}`,
              format: "red-bold"
            }
          ]);
        }
      } else if (dataInfo.note_type == "callback") {
        dataInfo["notetxt"].push([
          {
            txt: `Client has requested a callback`,
            format: "blue-bold"
          }
        ]);
      } else if (
        dataInfo.note_type == "user has question" ||
        dataInfo.note_type == "question"
      ) {
        if (
          dataInfo.details.user_request != undefined &&
          dataInfo.details.user_request != null &&
          dataInfo.details.user_request != ""
        ) {
          dataInfo["notetxt"].push([
            {
              txt: `Client has following question:`,
              format: "bold-only"
            },
            {
              txt: `"${dataInfo.details.user_request}"`,
              format: "blue-regular"
            }
          ]);
        } else {
          dataInfo.notetxt.push([
            {
              txt: `${"Client has a question"}`,
              format: "blue-bold"
            }
          ]);
        }
      } else if (dataInfo.note_type == "service refused") {
        dataInfo["notetxt"].push([
          {
            txt: `Client has declined the offer for planned service`,
            format: "blue-bold"
          }
        ]);
      } else if (dataInfo.note_type == "service refuse reason") {
        dataInfo["notetxt"].push([
          {
            txt: `Client has declined the offer for planned service with the following reasons:`,
            format: "bold-only"
          },
          {
            txt: !dataInfo.details ? "" : dataInfo.details.user_request || "",
            format: "blue-regular"
          }
        ]);
      } else if (dataInfo.note_type == "new_car") {
        dataInfo["notetxt"].push([
          {
            txt: `Client is inquiring about new/unregistered vehicle`,
            format: "blue-bold"
          }
        ]);
      } else if (dataInfo.note_type == "couldn't identify customer") {
        dataInfo["notetxt"].push([
          {
            txt: `Bot wasn't able to identify customer`,
            format: "blue-bold"
          }
        ]);
      } else {
        dataInfo["notetxt"].push([
          {
            txt: `Notification type:`,
            format: "bold-only"
          },
          {
            txt: `${dataInfo.note_type}`,
            format: "blue-bold"
          }
        ]);
        if (dataInfo.details && dataInfo.details.user_request) {
          dataInfo["notetxt"].push([
            {
              txt: `Notification details:`,
              format: "bold-only"
            },
            {
              txt: `${dataInfo.details.user_request}`,
              format: "blue-regular"
            }
          ]);
        }
      }
      return dataInfo;
    }
  }
};
</script>
<style>
.padd-0 {
  padding: 0;
}
.vehnote-style {
  padding-top: 25px;
  border: 1px solid lightgrey;
  padding-bottom: 15px;
}
.bold-color-txt {
  margin-bottom: 0;
  font-weight: bold;
}
.request-style {
  border-bottom: 1px solid lightgray;
  padding-bottom: 5px;
}
.red-bold {
  font-weight: bold;
  color: darkred;
}

.blue-bold {
  font-weight: bold;
  color: rgb(3, 0, 153);
}

.blue-regular {
  color: rgb(3, 0, 153);
}

.bold-only {
  font-weight: bold;
}
</style>